/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { IPetColorItemResponse } from "../../services/pet-colors/pet-colors.interface";
import { IPetItemResponse } from "../../services/pet-list/pet-list.interface";
import { useAppointmentStore } from "../../hooks/redux-hooks/appointment-store/appointment.store";

interface IExpressAppointmentDetailsIndicator{
  isReschedule?: boolean;
}

const ExpressAppointmentDetailsIndicator = ({ isReschedule = false }: IExpressAppointmentDetailsIndicator) => {
  const { selectedPets, appointmentForm } = useAppointmentStore();
  const [selectedSlot, setSelectedSlot] = useState<string>("");
  const [selectedDate, setSelectedDate] = useState<string>("");

  const getPetIndicatorText = (pets: IPetColorItemResponse[]) => {
    const petNames = pets.map((pet) => pet.name);

    if (petNames.length === 1) return petNames[0];
    if (petNames.length === 2) return petNames.join(" and ");

    return `${petNames.slice(0, -1).join(", ")}, and ${petNames[petNames.length - 1]}`;
  };

  useEffect(() => {
    if (appointmentForm?.day && appointmentForm?.selectedSlotLabel) {
      setSelectedDate(appointmentForm?.day);
      setSelectedSlot(appointmentForm?.selectedSlotLabel);
    } else {
      setSelectedDate("");
      setSelectedSlot("");
    }
  }, [appointmentForm]);

  if (selectedPets.length < 1) {
    return null;
  }

  return (
    <div className="bg-taupe-15 p-1.5 text-sm mt-5 my-3 mx-4 shadow-sm
              flex tracking-wide cursor-default">
      <div className="grid grid-cols-[auto,1fr] gap-1">
        <div>
          {isReschedule ? "Reschedule for: " : "Booking for: "}
        </div>
        <div className="font-semibold">
          {getPetIndicatorText(selectedPets)}
          {selectedDate && (
            <span className="font-semibold">
              <span className="font-normal"> on </span>
              {selectedDate}
              <span className="uppercase">{selectedSlot && `, ${selectedSlot}`}</span>
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExpressAppointmentDetailsIndicator;
